import { RootState } from '@app/index';

export const selectHasInternetConnection = ({ connectivity }: RootState) => connectivity.hasInternetConnection;
